const ADMIN_CHECK = 'ADMIN_CHECK';
export {
	ADMIN_CHECK
};
